export default __webpack_public_path__ + "maps-examples-add-marker-symbol-960-4c8be650d122c0e9b473336c8773967a.png";